export default __webpack_public_path__ + "static/okr2-2a166e3b66b9668f69650394e34f56a1.jpeg";